// @flow
import styled from 'styled-components';
import { Button } from '../../../atoms';

export const Capitalize = styled.span`
  text-transform: capitalize;
`;

export const VariableWidthDiv = styled.div`
  width: ${props => props.width ? (props.width + '%') : '100%'};
  margin: 0 auto;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
`;

export const LinkButton = styled(Button)`
  ::after {
    content: '${({contentMobile}) => contentMobile}';
    @media (min-width: 840px) {
      content: '${({contentDesktop}) => contentDesktop}';
    }
  }
  font-size: .8em;
  background-color: ${props => props.inverseStyle === true ? '#ffffff' : '#2397d4'};
  color: ${props => props.inverseStyle === false ? '#ffffff' : '#2397d4'};
  border-radius: 5px;
  text-transform: uppercase;
  width: 100%;
  @media screen and (min-width: 550px) {
    font-size: 1.15em;
  }
  @media screen and (max-width: 840px) {
    display: ${props => props.contentMobile != null ? 'block' : 'none'}
  }
`;
